import { Vue, Options } from 'vue-class-component';
import { v4 as uuidv4 } from 'uuid';

@Options({
  name: 'InlineSvgScoped',
  props: {
    src: {
      required: true,
      type: String,
    },
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
    fill: {
      type: String,
    },
    ariaLabel: {
      type: String,
    },
  },
})
export default class InlineSvgScoped extends Vue {
  private nameMap = {} as any;
  private static readonly attributesToReplace = [
    'fill',
    'filter',
    'mask',
    'clip-path',
  ];

  transform(svg: SVGSVGElement) {
    this.makeIdsUnique(svg.children);
    return svg;
  }

  makeIdsUnique(elements: HTMLCollection) {
    if (!elements) return;
    for (const item of elements) {
      if (item.id) {
        //generate a new id for each icon
        const newName = item.id + uuidv4();
        this.nameMap[`#${item.id}`] = `#${newName}`;
        item.id = newName;
      }
      //search for generated ids and substite them in xlink:href (used for example in use tag)
      const xhref = item.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
      if (xhref) {
        const newHrefId = this.nameMap[xhref];
        if (newHrefId) {
          item.setAttributeNS(
            'http://www.w3.org/1999/xlink',
            'xlink:href',
            newHrefId
          );
        }
      }

      //search for generated ids and substite them in attributes with the form url(#id)
      const attrs = item.attributes;
      for (let i = attrs.length - 1; i >= 0; i--) {
        this.setAttributeId(item, attrs[i].name, attrs[i].value);
      }

      this.makeIdsUnique(item.children);
    }
  }

  setAttributeId(item: Element, attributeName: string, attributeValue: string) {
    if (!InlineSvgScoped.attributesToReplace.includes(attributeName)) return;
    if (attributeValue) {
      const regex = /url\((#[^)]*)/gm;
      const match = attributeValue.matchAll(regex).next();
      if (!match?.value) return;
      const originalMaskName = match.value[1];
      const newMaskName = this.nameMap[originalMaskName];

      if (newMaskName)
        item.setAttribute(
          attributeName,
          attributeValue.replace(regex, `url(${newMaskName}`)
        );
    }
  }
}
